import React from 'react';
import ReactEmbedGist from 'react-embed-gist';
const IntegrationGuide = () =>{
    return <>
    
    <ReactEmbedGist gist="imabp/f06bea701933b5697ca9c6261722ec2c"/>
    </>
}
export default IntegrationGuide;